var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view_box",class:_vm.isAni ? 'ani':''},[_c('div',[_vm._v("2024年")]),_c('div',[_vm._v("云宝和你一起")]),_c('div',[_vm._v("探索用户持续确定性增长")])])
}
var staticRenderFns = []

export { render, staticRenderFns }